var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAllyCrowley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 34,
    viewBox: "0 0 133 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12105_6312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.898193H132.089V33.7492H0V0.898193Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12105_6312)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12105_6312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 134,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    y: 0.897949,
    width: 132.088,
    height: 32.8507,
    fill: "url(#pattern0_12105_6312)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12105_6312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00195312,
    y: 0.897949,
    width: 132.088,
    height: 32.8507,
    fill: "url(#pattern1_12105_6312)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_12105_6312",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12105_6312",
    transform: "scale(0.00625 0.025)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_12105_6312",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_12105_6312",
    transform: "scale(0.00625 0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12105_6312",
    width: 160,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAAAoCAAAAABcR65EAAAAAmJLR0QA/4ePzL8AAAPpSURBVFiF7Zjbkds2GIU/ZVIA0gEmFbCDZSpYdSC6AskViK5A7EDrCrRuwJAr0KYBg27AVBrAyQMA3qRs/MadxP/OrEji9ukA/4WCn/Yft9XounwoCgtt+/LpvBDOK2b2XQjKf35rlwaaWekVJAUlC183SyNN7JDYwujjZJem6s24pN5ERHm7NFi2y4wsKhjCWyE8KCiEHi30jMEtjQZANWzvVEcp7JaGA/Ca2ITwu1ma7lcqO7rVipVYaaUYwX/b1bMB5frB0LYfz8D6EYC/ns+51W7W1lxfnr60QLmBbzVQrKG5gt0D7yg3cP6Yhxz7qT+0dg+8v5K72odvYwG75jTVMSg8T/Gsyx2OwNPc3w/9gw1gJHWkfo/AWpKLZ6rHssN2leAk1XlITVVvKYcOFtY++0cIIUjd44Sv6PrOuzGgoje5YS7tgIukgqhBAzTx+SuAtpM6G596sNWaum/3AFTjlOLshM96SfLH48mrTIBVWfk4edSva+rIXUAdgQolKV1U4QbwqSzLsiwNccgxzpxSmZsBYp9iOgnBl9P9jYpFxy5Nuk8LNkmLpv8iDsq42i7r08VFbgDr0RpekrWjHn4OCPYkBXVb5uZnkyXAxFEPc5SSZDKRkzqppkhf4FXAUtIxTQyAbgGh8t3hNsAYjcaNAPdRV9fLC13c4ydJxkiqJccuHYUbwM57730SJDlqD30X8L7ZdJQmgE19StwurQ/xuoooj2vJWUnmlIb/g5MkJNNNYH65i1J8vvxotbXdr4H3bVpu1NLBM/DHGj61LawtfPn3Ca8fAN7193fOoDkEpVA2MaORRjAKM8d81yROxS3GSc5LBY10yp55o2BjrbW2P1PT3bzxYrY52B3HeuS+lzRP9uJtdYmhi7XSRQw4HrIDe3K4tXcB6+kyU8BmBlhe+gdBhyliJUl+U5hi62qyk5RKgdpL8huDPSiLZbPA8WS5fpofBxwySWdyKuvL1+CLGwlHu/o0eMdmMpWkSxzhpZjmnJSdvBp6pZzhnHPO5TM1BWTIXn677ySNakOFI2Ozg7zPTOJgZ6YrOzPaIEPa7OI+YLIs5AxwyHV9uRpf74JuAKHyCWAzAOIkHQBscpuuryP7/TeahvEfBVxhvAHQ5BUZsUIr9Hs7I8QWhuv5ClAYOAPWEi/AFgXdn+ehe2FoW4ASXq6JsG89Y4ZD1LZ98/VltOIul1axhhnJ2YeNhW2oAtUXgvHTL15QA2B8wgqzgv+rXRotmfU3EgZpHmOWtBT+Qv9Pekvv7QB1N31zD+FOvbWo2eP39IOCJHU3efgNmNmcYqLwx+3bUW81u7fQLoDx0/7H9jfKJJtxe6yWNQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_12105_6312",
    width: 160,
    height: 40,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAllyCrowley);
export default __webpack_public_path__ + "static/media/logo_ally_crowley.704d6c43623881b98cb0f540f693d6c0.svg";
export { ForwardRef as ReactComponent };